import { render, staticRenderFns } from "./SalaryCompany.vue?vue&type=template&id=b9cf6974&scoped=true"
import script from "./SalaryCompany.vue?vue&type=script&lang=js"
export * from "./SalaryCompany.vue?vue&type=script&lang=js"
import style0 from "./SalaryCompany.vue?vue&type=style&index=0&id=b9cf6974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cf6974",
  null
  
)

export default component.exports